import { Link } from 'react-router-dom';
import { useExperiences } from '../api/queries';
import { CardSkeletonGrid, EmptyState, MediaImage, Reveal } from '../components/ui';

interface ExperienceGridData {
  heading?: string;
  linkLabel?: string;
  linkHref?: string;
  limit?: number;
}

/** Upcoming experiences, pulled live from the API and limited by the block's setting. */
export function ExperienceGridBlock({ data }: { data: ExperienceGridData }) {
  const { data: experiences, isLoading } = useExperiences(true);
  const items = (experiences ?? []).slice(0, data.limit ?? 3);

  return (
    <section className="sz-section" aria-labelledby="experiences-heading">
      <div className="sz-section__inner">
        <div className="sz-section-head">
          <h2 id="experiences-heading">{data.heading ?? 'Upcoming Experiences'}</h2>
          {data.linkHref && (
            <Link to={data.linkHref} className="sz-link-caps">
              {data.linkLabel ?? 'All Experiences →'}
            </Link>
          )}
        </div>

        {isLoading && <CardSkeletonGrid count={3} height={300} />}

        {!isLoading && items.length === 0 && (
          <EmptyState message="No experiences are published at the moment." />
        )}

        {items.length > 0 && (
          <div className="sz-card-grid">
            {items.map((experience, index) => (
              <Reveal key={experience.id} delay={index * 80} as="article">
                <Link to="/experiences" className="sz-experience-card">
                  <MediaImage
                    media={experience.image}
                    alt={experience.title}
                    className="sz-experience-card__media"
                    placeholder={experience.title}
                    zoomOnHover
                    sizes="(max-width: 900px) 100vw, 33vw"
                  />
                  <div className="sz-experience-card__body">
                    <p className="sz-experience-card__when">{experience.scheduleLabel}</p>
                    <h4 className="sz-experience-card__title">{experience.title}</h4>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
